<template>
    <div class="w-full space-y-8" v-if="dailyBriefing">
        <ui-header :title="`Daily Briefing ${dailyBriefing.date}`">
        </ui-header>
        <ui-data-grid>
            <ui-data-grid-item label="Package" wide :value="dailyBriefing.packageName"></ui-data-grid-item>
            <ui-data-grid-item label="Date" :value="dailyBriefing.date"></ui-data-grid-item>
            <ui-data-grid-item label="Reference" :value="dailyBriefing.id"></ui-data-grid-item>
            <ui-data-grid-item label="Location of Works" wide :value="dailyBriefing.location"></ui-data-grid-item>
            <ui-data-grid-item label="Key Activities" wide :value="dailyBriefing.keyActivities"></ui-data-grid-item>
            <ui-data-grid-item label="Key Hazards" wide :value="dailyBriefing.keyHazards"></ui-data-grid-item>
            <ui-data-grid-item label="Attendees" wide>
                <div class="flex mt-8 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                    <div class="w-6 flex-shrink-0"></div>
                    <div class="flex-1 border-l border-r border-gray-200 px-2 py-1">Name</div>
                    <div class="flex-1 border-r border-gray-200 px-2 py-1">Position</div>
                    <div class="w-20 border-r border-gray-200 px-2 py-1">Signature</div>
                    <div class="w-6 flex-shrink-0 ml-2"></div>
                </div>
                <div class="flex border-collapse border-b border-gray-200 draggable"
                     v-for="attendee in dailyBriefing.attendees">
                    <div class="w-6 flex-shrink-0">
                    </div>
                    <div class="flex-1 border-l border-r">
                        <div class="flex-1 border-gray-200 px-0 py-0 overflow-x-auto relative">
                            <div class="text-sm px-2 py-1">
                                {{ attendee.name ? attendee.name : "&nbsp;" }}
                            </div>
                        </div>
                    </div>
                    <div class="flex-1 border-r border-gray-200 px-0 py-0">
                        <div class="flex-1 border-gray-200 px-0 py-0 overflow-x-auto relative">
                            <div class="text-sm px-2 py-1">
                                {{ attendee.position ? attendee.position : "&nbsp;" }}
                            </div>
                        </div>
                    </div>
                    <div class="w-20 flex border-r border-gray-200 px-0 py-0 relative">
                        <img v-if="attendee.signature" :src="attendee.signature" height="28px" width="100%"
                             class="m-0 p-0 absolute"
                             style="right:0px; top:0px; height:28px; z-index: 20">
                    </div>
                    <div class="w-6 flex-shrink-0 ml-2 mt-1">
                    </div>
                </div>
            </ui-data-grid-item>
            <ui-data-grid-item label="Given By" :value="dailyBriefing.givenByName"></ui-data-grid-item>
            <ui-data-grid-item label="Position" :value="dailyBriefing.givenByPosition"></ui-data-grid-item>
            <ui-data-grid-item label="Signed">
                <img v-if="dailyBriefing.signature" :src="dailyBriefing.signature" height="128px" width="auto"
                     class="m-0 p-0"
                     style="right:0px; top:0px; height:128px; z-index: 20">
                <span v-else>-</span>
            </ui-data-grid-item>
        </ui-data-grid>
    </div>
</template>

<script>

import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import PackageContactSearch from "../../contacts/PackageContactSearch.vue";

export default {
    components: {PackageContactSearch, UiDropdown, UiDropdownItem},
    props: {
        dailyBriefing: Object,
    },
    data() {
        return {}
    },
    methods: {
        isMimeTypeSupported(mimeType) {
            return ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/heic'].includes(mimeType.toLowerCase())
        },
    },
    async mounted() {
    }
}
</script>
